import React, { useState } from "react";
import { Controller, FormProvider, useForm } from "react-hook-form";
import "./styles.sass";
import { useSearchParams } from "react-router-dom";
import { usePromoCode } from "../../../queries/useGetPromocode";
import useTranslate from "../../../hooks/useTranslate";
import { getErrorMessage } from "../../../utils/getPromocodeError";

interface IPromocodeFieldProps {
  code: string;
}

const PromocodeField = () => {
  const [responseMessage, setResponseMessage] = useState<string>("");
  const [, setSearchParams] = useSearchParams();
  const [isFieldFocused, setFieldFocused] = useState(false);
  const t = useTranslate();
  const { mutate, isPending } = usePromoCode({
    onSuccess: () => {
      setSearchParams({ popup: "promocode-apply" });
      setResponseMessage("");
    },
    onError: (error) => {
      const errorRes = getErrorMessage(t, error.errorCode);
      setResponseMessage(errorRes);
    },
  });

  const methods = useForm<IPromocodeFieldProps>({
    defaultValues: {
      code: "",
    },
    mode: "onBlur",
  });

  const onSubmit = (data: IPromocodeFieldProps) => {
    mutate({ code: data.code });
    methods.reset();
  };

  const codeValue = methods.watch("code");
  const isDisabled =
    isPending ||
    !codeValue.trim() ||
    (isFieldFocused && codeValue.trim() === "");

  return (
    <div className="promo__wrapper">
      <FormProvider {...methods}>
        <form
          className="promo__container"
          onSubmit={(e) => {
            e.preventDefault();
            if (!isDisabled) {
              methods.handleSubmit(onSubmit)();
            }
          }}
        >
          <Controller
            name="code"
            control={methods.control}
            rules={{
              validate: (value) => {
                return /^[a-zA-Z0-9-_]+$/.test(value);
              },
            }}
            render={({ field, fieldState }) => (
              <>
                <input
                  {...field}
                  type="text"
                  className="promo__container-input"
                  placeholder={t("promocode.apply.form.placeholder")}
                  onFocus={() => setFieldFocused(true)}
                  onBlur={() => setFieldFocused(false)}
                  onChange={(e) => {
                    field.onChange(
                      e.target.value
                        .replace(/[^a-zA-Z0-9-_]/g, "")
                        .replace(/\s+/g, ""),
                    );
                  }}
                />
                {fieldState.error?.message && <p>{fieldState.error.message}</p>}
              </>
            )}
          />

          <button
            type="submit"
            className="promo__container-button"
            disabled={isDisabled}
          >
            {t("promocode.apply.form.button")}
          </button>
        </form>
      </FormProvider>
      {responseMessage && (
        <p className="promo__container-error">{responseMessage}</p>
      )}
    </div>
  );
};

export default PromocodeField;
